import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Category, NearbyRestaurants, OrderType, RestaurantInfo } from '../../(routes)/online-ordering/types';
import { RestaurantMetadata } from './restaurantSliceTypes';

export interface RestaurantState {
  selectedRestaurant: RestaurantInfo | undefined;
  viewOnly: boolean;
  isQr: boolean;
  isCatering: boolean;
  orderType: OrderType | string;
  onlineOrderingSettings: boolean;
  businessId: number[];
  qrType: string | null;
  qrId: number | null;
  tenantName: string | null;
  scheduleOrder: boolean;
  selectedPickupDeliveryDate: string;
  selectedCategory: Category | null;
  showMenu: boolean | undefined;
  selectedBusinessId: null | number;
  step: number | null;
  tableId: number | null;
  tableNo?: string | null;
  activeRestaurant: RestaurantMetadata | null;
  editOrderType: boolean;
  selectedRestaurantAddressNew: NearbyRestaurants;
  refetchLoyaltyPoints: boolean;
  open: boolean;
}

const initialState: RestaurantState = {
  selectedRestaurant: undefined,
  viewOnly: false,
  isQr: false,
  isCatering: false,
  orderType: '',
  onlineOrderingSettings: false,
  businessId: [],
  qrType: null,
  qrId: null,
  tenantName: null,
  scheduleOrder: false,
  selectedPickupDeliveryDate: '',
  selectedCategory: null,
  showMenu: undefined,
  selectedBusinessId: null,
  step: null,
  tableId: null,
  tableNo: null,
  activeRestaurant: null,
  editOrderType: false,
  selectedRestaurantAddressNew: {},
  refetchLoyaltyPoints: false,
  open: true,
};

export const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    setSelectedRestaurant: (state, action: PayloadAction<any>) => {
      state.selectedRestaurant = action.payload;
    },
    setActiveRestaurant: (state, action: PayloadAction<any>) => {
      state.activeRestaurant = action.payload;
    },
    setRestaurantSetting: (state, action: PayloadAction<any>) => {
      for (const key in action?.payload) {
        (state as any)[key] = action?.payload[key];
      }
    },
    setRefetchLoyaltyPoints: (state, action: PayloadAction<boolean>) => {
      state.refetchLoyaltyPoints = action.payload;
    },
    resetRefetchLoyaltyPoints: (state) => {
      state.refetchLoyaltyPoints = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSelectedRestaurant,
  setRestaurantSetting,
  setRefetchLoyaltyPoints,
  resetRefetchLoyaltyPoints,
  setActiveRestaurant,
} = restaurantSlice.actions;

export default restaurantSlice.reducer;
